import React, { useState, useEffect } from 'react';
import '../../styles/Gallery.css';
import '../../styles/Fonts.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

// Import images
import Carnet1 from '../../assets/EditedFiles/carnet1.webp';
import Carnet2 from '../../assets/EditedFiles/carnet3.webp';
import Carnet3 from '../../assets/EditedFiles/carnet2.webp';
import Carnet4 from '../../assets/EditedFiles/carnet5.webp';
import Carnet5 from '../../assets/EditedFiles/carnet6.webp';
import Carnet6 from '../../assets/EditedFiles/carnet7.webp';
import Cargo1 from '../../assets/EditedFiles/cargo1.webp';
import Cargo2 from '../../assets/EditedFiles/cargo2.webp';
import Cargo3 from '../../assets/EditedFiles/cargo3.webp';
import Cargo4 from '../../assets/EditedFiles/cargo4.webp';
import Cargo5 from '../../assets/EditedFiles/cargo7.webp';
import Cargo6 from '../../assets/EditedFiles/cargo8.webp';
import Cargo7 from '../../assets/EditedFiles/cargo5.webp';
import Cargo8 from '../../assets/EditedFiles/cargo9.webp';
import Cargo9 from '../../assets/EditedFiles/cargonew1.webp';
import Cargo10 from '../../assets/EditedFiles/cargonew2.webp';
import Cargo11 from '../../assets/EditedFiles/cargonew3.webp';
import Cargo12 from '../../assets/EditedFiles/cargonew4.webp';
import Cargo13 from '../../assets/EditedFiles/cargonew5.webp';
import Cargo15 from '../../assets/EditedFiles/cargonew7.webp';
import Cargo16 from '../../assets/EditedFiles/cargonew8.webp';
import Cargo17 from '../../assets/EditedFiles/cargonew9.webp';
import Cargo18 from '../../assets/EditedFiles/cargonew10.webp';
import CargoPhoto0 from '../../assets/EditedFiles/cargo.jpg';
import CargoPhoto1 from '../../assets/EditedFiles/cargo1.jpg';
import CargoPhoto2 from '../../assets/EditedFiles/cargo2.jpg';
import CargoPhoto3 from '../../assets/EditedFiles/cargo3.jpg';
import CargoPhoto4 from '../../assets/EditedFiles/cargo4.jpg';
import CargoPhoto5 from '../../assets/EditedFiles/cargo5.jpg';
import CargoPhoto6 from '../../assets/EditedFiles/cargo6.jpg';
import CargoPhoto7 from '../../assets/EditedFiles/cargo7.jpg';
import CargoPhoto8 from '../../assets/EditedFiles/cargo8.jpg';
import CargoPhoto9 from '../../assets/EditedFiles/cargo9.jpg';
import CargoPhoto10 from '../../assets/EditedFiles/cargo10.jpg';
import CargoPhoto11 from '../../assets/EditedFiles/cargo11.jpg';
import CargoPhoto12 from '../../assets/EditedFiles/cargo12.jpg';
import CargoPhoto13 from '../../assets/EditedFiles/cargo13.jpg';
import CargoPhoto14 from '../../assets/EditedFiles/cargo14.jpg';
import CargoPhoto15 from '../../assets/EditedFiles/cargo15.jpg';
import CargoPhoto16 from '../../assets/EditedFiles/cargo16.jpg';
import CargoPhoto17 from '../../assets/EditedFiles/cargo17.jpg';
import CargoPhoto18 from '../../assets/EditedFiles/cargo18.jpg';
import CargoPhoto19 from '../../assets/EditedFiles/cargo19.jpg';
import CargoPhoto20 from '../../assets/EditedFiles/cargo20.jpg';
import CargoPhoto21 from '../../assets/EditedFiles/cargo21.jpg';
import CargoPhoto22 from '../../assets/EditedFiles/cargo22.jpg';
import CargoPhoto23 from '../../assets/EditedFiles/cargo23.jpg';
import WorldPhoto0 from '../../assets/EditedFiles/world.jpg';
import WorldPhoto1 from '../../assets/EditedFiles/world1.jpg';
import WorldPhoto2 from '../../assets/EditedFiles/world2.jpg';
import WorldPhoto3 from '../../assets/EditedFiles/world3.jpg';
import WorldPhoto4 from '../../assets/EditedFiles/world4.jpg';
import WorldPhoto5 from '../../assets/EditedFiles/world5.jpg';
import WorldPhoto6 from '../../assets/EditedFiles/world6.jpg';
import WorldPhoto7 from '../../assets/EditedFiles/world7.jpg';
import WorldPhoto8 from '../../assets/EditedFiles/world8.jpg';
import WorldPhoto9 from '../../assets/EditedFiles/world9.jpg';
import WorldPhoto10 from '../../assets/EditedFiles/world10.jpg';
import WorldPhoto11 from '../../assets/EditedFiles/world11.jpg';
import WorldPhoto12 from '../../assets/EditedFiles/world12.jpg';
import WorldPhoto13 from '../../assets/EditedFiles/world13.jpg';
import WorldPhoto14 from '../../assets/EditedFiles/world14.jpg';
import WorldPhoto15 from '../../assets/EditedFiles/world15.jpg';
import WorldPhoto16 from '../../assets/EditedFiles/world16.jpg';
import WorldPhoto17 from '../../assets/EditedFiles/world17.jpg';
import WorldPhoto18 from '../../assets/EditedFiles/world18.jpg';
import WorldPhoto19 from '../../assets/EditedFiles/world19.jpg';
import WorldPhoto20 from '../../assets/EditedFiles/world20.png';
import WorldPhoto21 from '../../assets/EditedFiles/world21.jpg';
import WorldPhoto22 from '../../assets/EditedFiles/world22.jpg';
import WorldPhoto23 from '../../assets/EditedFiles/world23.webp';
import WorldPhoto24 from '../../assets/EditedFiles/world24.jpg';
import WorldPhoto26 from '../../assets/EditedFiles/world26.jpg';
import WorldPhoto27 from '../../assets/EditedFiles/world27.webp';
import WorldPhoto28 from '../../assets/EditedFiles/world28.jpg';
import WorldPhoto29 from '../../assets/EditedFiles/world29.jpg';
import WorldPhoto30 from '../../assets/EditedFiles/world30.jpg';
import WorldPhoto31 from '../../assets/EditedFiles/world31.webp';
import WorldPhoto32 from '../../assets/EditedFiles/world32.jpg';
import WorldPhoto33 from '../../assets/EditedFiles/world33.jpg';
import WorldPhoto34 from '../../assets/EditedFiles/world34.jpg';
import WorldPhoto35 from '../../assets/EditedFiles/world35.jpg';
import WorldPhoto36 from '../../assets/EditedFiles/world36.jpg';
import WorldPhoto37 from '../../assets/EditedFiles/world37.jpg';
import WorldPhoto38 from '../../assets/EditedFiles/world38.jpg';
import WorldPhoto39 from '../../assets/EditedFiles/world39.png';
import kodaline from '../../assets/EditedFiles/kodaline.jpg';
import Mitski from '../../assets/EditedFiles/Mitski.jpg';
import concert1 from '../../assets/EditedFiles/con1.webp';
import concert2 from '../../assets/EditedFiles/con2.webp';
import concert3 from '../../assets/EditedFiles/con3.webp';
import concert4 from '../../assets/EditedFiles/con4.webp';
import concert5 from '../../assets/EditedFiles/con5.webp';
import concert6 from '../../assets/EditedFiles/con6.webp';
import concert7 from '../../assets/EditedFiles/con7.webp';
import concert8 from '../../assets/EditedFiles/con8.webp';
import concert9 from '../../assets/EditedFiles/newcon7.webp';
import concert10 from '../../assets/EditedFiles/newcon1.webp';
import concert11 from '../../assets/EditedFiles/newcon2.webp';
import concert12 from '../../assets/EditedFiles/newcon3.webp';
import concert13 from '../../assets/EditedFiles/newcon4.webp';
import concert14 from '../../assets/EditedFiles/newcon5.webp';
import concert15 from '../../assets/EditedFiles/newcon6.webp';
import concert16 from '../../assets/EditedFiles/connew1.webp';

import concert17 from '../../assets/EditedFiles/concert_rcs1.webp';
import concert18 from '../../assets/EditedFiles/concert_rcs2.webp';
import concert19 from '../../assets/EditedFiles/concert_rcs3.webp';
import concert20 from '../../assets/EditedFiles/concert_rcs4.webp';
import concert21 from '../../assets/EditedFiles/concert_rcs5.webp';
import concert22 from '../../assets/EditedFiles/concert_rcs6.webp';
import concert23 from '../../assets/EditedFiles/concert_rcs7.webp';
import concert24 from '../../assets/EditedFiles/concert_rcs8.webp';
import concert26 from '../../assets/EditedFiles/concert_rcs10.webp';
import concert27 from '../../assets/EditedFiles/concert_rcs11.webp';
import concert28 from '../../assets/EditedFiles/concert_rcs12.webp';
import concert29 from '../../assets/EditedFiles/concert_rcs13.webp';
import concert30 from '../../assets/EditedFiles/concert_rcs14.webp';
import concert31 from '../../assets/EditedFiles/concert_rcs15.webp';
import concert32 from '../../assets/EditedFiles/concert_rcs16.webp';
import concert33 from '../../assets/EditedFiles/concert_rcs17.webp';
import concert34 from '../../assets/EditedFiles/concert_rcs18.webp';
import fifa from '../../assets/EditedFiles/fifa.jpg';

import project1 from '../../assets/EditedFiles/project1.webp';
import project2 from '../../assets/EditedFiles/project2.webp';
import project3 from '../../assets/EditedFiles/project3.webp';
import project4 from '../../assets/EditedFiles/project4.webp';
import project5 from '../../assets/EditedFiles/project5.webp';
import project6 from '../../assets/EditedFiles/project6.webp';
import project7 from '../../assets/EditedFiles/project7.webp';
import project8 from '../../assets/EditedFiles/project8.webp';
import project9 from '../../assets/EditedFiles/project9.webp';
import project10 from '../../assets/EditedFiles/project10.webp';
import project11 from '../../assets/EditedFiles/project11.jpg';
import project12 from '../../assets/EditedFiles/project12.jpg';
import project13 from '../../assets/EditedFiles/project13.jpg';
import project14 from '../../assets/EditedFiles/project14.jpg';
import project15 from '../../assets/EditedFiles/project15.jpg';
import project16 from '../../assets/EditedFiles/project16.jpg';
import project17 from '../../assets/EditedFiles/project17.jpg';
import project18 from '../../assets/EditedFiles/project18.jpg';
import project19 from '../../assets/EditedFiles/project19.jpg';
import project20 from '../../assets/EditedFiles/project20.jpg';
import project21 from '../../assets/EditedFiles/project21.jpg';
import project22 from '../../assets/EditedFiles/project22.jpg';
import project23 from '../../assets/EditedFiles/project23.jpg';
import project24 from '../../assets/EditedFiles/project24.jpg';
import project25 from '../../assets/EditedFiles/project25.jpg';
import project26 from '../../assets/EditedFiles/project26.jpg';
import project27 from '../../assets/EditedFiles/project27.jpg';
import project28 from '../../assets/EditedFiles/project28.jpg';
import project29 from '../../assets/EditedFiles/project29.jpg';
import project30 from '../../assets/EditedFiles/project30.jpg';
import project31 from '../../assets/EditedFiles/project31.jpg';
import project32 from '../../assets/EditedFiles/project32.jpg';
import project33 from '../../assets/EditedFiles/project33.jpg';
import project34 from '../../assets/EditedFiles/project34.jpg';
import project35 from '../../assets/EditedFiles/project35.jpg';
import project36 from '../../assets/EditedFiles/project36.jpg';
import project37 from '../../assets/EditedFiles/project37.jpg';
import project38 from '../../assets/EditedFiles/project38.jpg';
import project39 from '../../assets/EditedFiles/project39.jpg';
import project40 from '../../assets/EditedFiles/project40.jpg';
import projectcargo1 from '../../assets/EditedFiles/Projectcargo1.jpg';
import projectcargo2 from '../../assets/EditedFiles/Projectcargo2.jpg';
import projectcargo3 from '../../assets/EditedFiles/Projectcargo3.jpg';
import projectcargo4 from '../../assets/EditedFiles/Projectcargo4.jpg';
import projectcargo5 from '../../assets/EditedFiles/Projectcargo5.jpg';

import stvincent from '../../assets/EditedFiles/St. Vincent.jpg';
import cigs from '../../assets/EditedFiles/Cigs.jpg';
import maroon5 from '../../assets/EditedFiles/Maroon5.jpg';
import niki from '../../assets/EditedFiles/Niki.jpg';
import wanderland from '../../assets/EditedFiles/Wanderland.jpg';
import toto from '../../assets/EditedFiles/Toto.jpg';
import tylerthecreator from '../../assets/EditedFiles/Tylerthecreator.jpg';
import volleyball from '../../assets/EditedFiles/Volleyball.png';
import mayday from '../../assets/EditedFiles/MayDay.jpg';
import babymetal from '../../assets/EditedFiles/Babymetal.jpg';
import mariah from '../../assets/EditedFiles/Mariah.png';
import jasonderulo from '../../assets/EditedFiles/jason-derulo.jpg';
import lumineers from '../../assets/EditedFiles/lumineers.jpg';
import AtaPhoto0 from '../../assets/EditedFiles/ata.jpg';
import AtaPhoto1 from '../../assets/EditedFiles/ata1.jpg';
import AtaPhoto2 from '../../assets/EditedFiles/ata2.jpg';
import AtaPhoto3 from '../../assets/EditedFiles/ata3.jpg';
import AtaPhoto4 from '../../assets/EditedFiles/ata4.jpg';
import AtaPhoto5 from '../../assets/EditedFiles/ata5.jpg';
import AtaPhoto6 from '../../assets/EditedFiles/ata6.jpg';
import AtaPhoto7 from '../../assets/EditedFiles/ata7.jpg';
import AtaPhoto8 from '../../assets/EditedFiles/ata8.jpg';
import AtaPhoto9 from '../../assets/EditedFiles/ata9.jpg';
import AtaPhoto10 from '../../assets/EditedFiles/ata10.jpg';
import AtaPhoto11 from '../../assets/EditedFiles/ata11.jpg';
import AtaPhoto12 from '../../assets/EditedFiles/ata12.jpg';





const GallerySec = () => {
  const [filter, setFilter] = useState('Concerts');
  const [modalImage, setModalImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [visibleImages, setVisibleImages] = useState([]);

  const handleFilterChange = (newFilter) => {
    setIsLoading(true);
    setFilter(newFilter);
    setVisibleImages([]);
    
    // Simulate loading and animate images in
    setTimeout(() => {
      setIsLoading(false);
      const filteredImages = getUniqueImages(images[newFilter] || []);
      filteredImages.forEach((_, index) => {
        setTimeout(() => {
          setVisibleImages(prev => [...prev, index]);
        }, index * 100);
      });
    }, 300);
  };

  const handleImageClick = (imgSrc) => {
    setModalImage(imgSrc);
  };

  const closeModal = () => {
    setModalImage(null);
  };

  const getUniqueImages = (imageList = []) => {
    const seenSources = new Set();
    return imageList.filter((img) => {
      if (!img?.src || seenSources.has(img.src)) return false;
      seenSources.add(img.src);
      return true;
    });
  };

  // Initialize with all images visible
  useEffect(() => {
    const filteredImages = getUniqueImages(images[filter] || []);
    filteredImages.forEach((_, index) => {
      setTimeout(() => {
        setVisibleImages(prev => [...prev, index]);
      }, index * 50);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Get filtered images (no search functionality)
  const getFilteredImages = () => {
    return getUniqueImages(images[filter] || []);
  };

  const images = {
    All: [
      { src: WorldPhoto39, category: 'World Tours' },
      { src: WorldPhoto38, category: 'World Tours' },
      { src: WorldPhoto37, category: 'World Tours' },
      { src: WorldPhoto36, category: 'World Tours' },
      { src: lumineers, category: 'World Tours' },
      { src: jasonderulo, category: 'World Tours' },
      { src: fifa, category: 'World Tours' },
      { src: mariah, category: 'World Tours' },
      { src: babymetal, category: 'World Tours' },
      { src: mayday, category: 'World Tours' },
      { src: volleyball, category: 'World Tours' },
      { src: tylerthecreator, category: 'World Tours' },
      { src: toto, category: 'World Tours' },
      { src: wanderland, category: 'World Tours' },
      { src: niki, category: 'World Tours' },
      { src: maroon5, category: 'World Tours' },
      { src: cigs, category: 'World Tours' },
      { src: stvincent, category: 'World Tours' },
      { src: concert1, category: 'World Tours' },
      { src: concert2, category: 'World Tours' },
      { src: concert3, category: 'World Tours' },
      { src: concert4, category: 'World Tours' },
      { src: concert5, category: 'World Tours' },
      { src: concert6, category: 'World Tours' },
      { src: concert8, category: 'World Tours' },
      { src: concert9, category: 'World Tours' },
      { src: concert10, category: 'World Tours' },
      { src: concert11, category: 'World Tours' },
      { src: concert12, category: 'World Tours' },
      { src: concert13, category: 'World Tours' },
      { src: concert14, category: 'World Tours' },
      { src: concert15, category: 'World Tours' },
      { src: concert16, category: 'World Tours' },
      { src: WorldPhoto0, category: 'World Tours' },
      { src: WorldPhoto1, category: 'World Tours' },
      { src: WorldPhoto2, category: 'World Tours' },
      { src: WorldPhoto3, category: 'World Tours' },
      { src: WorldPhoto4, category: 'World Tours' },
      { src: WorldPhoto5, category: 'World Tours' },
      { src: WorldPhoto6, category: 'World Tours' },
      { src: WorldPhoto7, category: 'World Tours' },
      { src: WorldPhoto8, category: 'World Tours' },
      { src: WorldPhoto9, category: 'World Tours' },
      { src: WorldPhoto10, category: 'World Tours' },
      { src: WorldPhoto11, category: 'World Tours' },
      { src: WorldPhoto12, category: 'World Tours' },
      { src: WorldPhoto13, category: 'World Tours' },
      { src: WorldPhoto14, category: 'World Tours' },
      { src: WorldPhoto15, category: 'World Tours' },
      { src: WorldPhoto16, category: 'World Tours' },
      { src: WorldPhoto17, category: 'World Tours' },
      { src: WorldPhoto18, category: 'World Tours' },
      { src: WorldPhoto19, category: 'World Tours' },
      { src: WorldPhoto20, category: 'World Tours' },
      { src: WorldPhoto21, category: 'World Tours' },
      { src: WorldPhoto22, category: 'World Tours' },
      { src: WorldPhoto23, category: 'World Tours' },
      { src: WorldPhoto24, category: 'World Tours' },
      { src: WorldPhoto26, category: 'World Tours' },
      { src: WorldPhoto27, category: 'World Tours' },
      { src: WorldPhoto28, category: 'World Tours' },
      { src: WorldPhoto29, category: 'World Tours' },
      { src: WorldPhoto30, category: 'World Tours' },
      { src: WorldPhoto31, category: 'World Tours' },
      { src: WorldPhoto32, category: 'World Tours' },
      { src: WorldPhoto33, category: 'World Tours' },
      { src: WorldPhoto34, category: 'World Tours' },
      { src: WorldPhoto35, category: 'World Tours' },
      { src: Carnet1, category: 'Pandemic Response' },
      { src: Carnet2, category: 'Pandemic Response' },
      { src: Carnet3, category: 'Pandemic Response' },
      { src: AtaPhoto0, category: 'ATA-CARNET' },
      { src: AtaPhoto1, category: 'ATA-CARNET' },
      { src: AtaPhoto2, category: 'ATA-CARNET' },
      { src: AtaPhoto3, category: 'ATA-CARNET' },
      { src: AtaPhoto4, category: 'ATA-CARNET' },
      { src: AtaPhoto5, category: 'ATA-CARNET' },
      { src: AtaPhoto6, category: 'ATA-CARNET' },
      { src: AtaPhoto7, category: 'ATA-CARNET' },
      { src: AtaPhoto8, category: 'ATA-CARNET' },
      { src: AtaPhoto9, category: 'ATA-CARNET' },
      { src: AtaPhoto10, category: 'ATA-CARNET' },
      { src: AtaPhoto11, category: 'ATA-CARNET' },
      { src: AtaPhoto12, category: 'ATA-CARNET' },
      { src: projectcargo1, category: 'Project Cargo' },
      { src: projectcargo2, category: 'Project Cargo' },
      { src: projectcargo3, category: 'Project Cargo' },
      { src: projectcargo4, category: 'Project Cargo' },
      { src: projectcargo5, category: 'Project Cargo' },
      { src: Cargo1, category: 'Project Cargo' },
      { src: Cargo2, category: 'Project Cargo' },
      { src: Cargo3, category: 'Project Cargo' },
      { src: Cargo4, category: 'Project Cargo' },
      { src: Cargo5, category: 'Project Cargo' },
      { src: Cargo6, category: 'Project Cargo' },
      { src: Cargo7, category: 'Project Cargo' },
      { src: Cargo8, category: 'Project Cargo' },
      { src: Cargo9, category: 'Project Cargo' },
      { src: Cargo10, category: 'Project Cargo' },
      { src: Cargo11, category: 'Project Cargo' },
      { src: Cargo12, category: 'Project Cargo' },
      { src: Cargo13, category: 'Project Cargo' },
      { src: Cargo15, category: 'Project Cargo' },
      { src: Cargo16, category: 'Project Cargo' },
      { src: Cargo17, category: 'Project Cargo' },
      { src: Cargo18, category: 'Project Cargo' },
      { src: CargoPhoto0, category: 'Project Cargo' },
      { src: CargoPhoto1, category: 'Project Cargo' },
      { src: CargoPhoto2, category: 'Project Cargo' },
      { src: CargoPhoto3, category: 'Project Cargo' },
      { src: CargoPhoto4, category: 'Project Cargo' },
      { src: CargoPhoto5, category: 'Project Cargo' },
      { src: CargoPhoto6, category: 'Project Cargo' },
      { src: CargoPhoto7, category: 'Project Cargo' },
      { src: CargoPhoto8, category: 'Project Cargo' },
      { src: CargoPhoto9, category: 'Project Cargo' },
      { src: CargoPhoto10, category: 'Project Cargo' },
      { src: CargoPhoto11, category: 'Project Cargo' },
      { src: CargoPhoto12, category: 'Project Cargo' },
      { src: CargoPhoto13, category: 'Project Cargo' },
      { src: CargoPhoto14, category: 'Project Cargo' },
      { src: CargoPhoto15, category: 'Project Cargo' },
      { src: CargoPhoto16, category: 'Project Cargo' },
      { src: CargoPhoto17, category: 'Project Cargo' },
      { src: CargoPhoto18, category: 'Project Cargo' },
      { src: CargoPhoto19, category: 'Project Cargo' },
      { src: CargoPhoto20, category: 'Project Cargo' },
      { src: CargoPhoto21, category: 'Project Cargo' },
      { src: CargoPhoto22, category: 'Project Cargo' },
      { src: CargoPhoto23, category: 'Project Cargo' }
    ],
    Concerts: [
      { src: kodaline, category: 'World Tours' },
      { src: Mitski, category: 'World Tours' },
      { src: WorldPhoto39, category: 'World Tours' },
      { src: WorldPhoto38, category: 'World Tours' },
      { src: WorldPhoto37, category: 'World Tours' },
      { src: WorldPhoto36, category: 'World Tours' },
      { src: lumineers, category: 'World Tours' },
      { src: jasonderulo, category: 'World Tours' },
      { src: fifa, category: 'World Tours' },
      { src: mariah, category: 'World Tours' },
      { src: babymetal, category: 'World Tours' },
      { src: mayday, category: 'World Tours' },
      { src: volleyball, category: 'World Tours' },
      { src: tylerthecreator, category: 'World Tours' },
      { src: toto, category: 'World Tours' },
      { src: wanderland, category: 'World Tours' },
      { src: niki, category: 'World Tours' },
      { src: maroon5, category: 'World Tours' },
      { src: cigs, category: 'World Tours' },
      { src: stvincent, category: 'World Tours' },
      { src: concert18, category: 'World Tours' },
      { src: concert3, category: 'World Tours' },
      { src: concert7, category: 'World Tours' },
      { src: concert9, category: 'World Tours' },
      { src: concert8, category: 'World Tours' },
      { src: concert6, category: 'World Tours' },
      { src: concert31, category: 'World Tours' },
      { src: concert1, category: 'World Tours' },
      { src: concert2, category: 'World Tours' },
      { src: concert4, category: 'World Tours' },
      { src: concert5, category: 'World Tours' },
      { src: concert10, category: 'World Tours' },
      { src: concert11, category: 'World Tours' },
      { src: concert12, category: 'World Tours' },
      { src: concert13, category: 'World Tours' },
      { src: concert14, category: 'World Tours' },
      { src: concert15, category: 'World Tours' },
      { src: concert16, category: 'World Tours' },
      { src: concert17, category: 'World Tours' },
      { src: concert19, category: 'World Tours' },
      { src: concert20, category: 'World Tours' },
      { src: concert21, category: 'World Tours' },
      { src: concert22, category: 'World Tours' },
      { src: concert23, category: 'World Tours' },
      { src: concert24, category: 'World Tours' },
      { src: concert26, category: 'World Tours' },
      { src: concert27, category: 'World Tours' },
      { src: concert28, category: 'World Tours' },
      { src: concert29, category: 'World Tours' },
      { src: concert30, category: 'World Tours' },
      { src: concert32, category: 'World Tours' },
      { src: concert33, category: 'World Tours' },
      { src: concert34, category: 'World Tours' },
      { src: WorldPhoto0, category: 'World Tours' },
      { src: WorldPhoto1, category: 'World Tours' },
      { src: WorldPhoto2, category: 'World Tours' },
      { src: WorldPhoto3, category: 'World Tours' },
      { src: WorldPhoto4, category: 'World Tours' },
      { src: WorldPhoto5, category: 'World Tours' },
      { src: WorldPhoto6, category: 'World Tours' },
      { src: WorldPhoto7, category: 'World Tours' },
      { src: WorldPhoto8, category: 'World Tours' },
      { src: WorldPhoto9, category: 'World Tours' },
      { src: WorldPhoto10, category: 'World Tours' },
      { src: WorldPhoto11, category: 'World Tours' },
      { src: WorldPhoto12, category: 'World Tours' },
      { src: WorldPhoto13, category: 'World Tours' },
      { src: WorldPhoto14, category: 'World Tours' },
      { src: WorldPhoto15, category: 'World Tours' },
      { src: WorldPhoto16, category: 'World Tours' },
      { src: WorldPhoto17, category: 'World Tours' },
      { src: WorldPhoto18, category: 'World Tours' },
      { src: WorldPhoto19, category: 'World Tours' },
      { src: WorldPhoto20, category: 'World Tours' },
      { src: WorldPhoto21, category: 'World Tours' },
      { src: WorldPhoto22, category: 'World Tours' },
      { src: WorldPhoto23, category: 'World Tours' },
      { src: WorldPhoto24, category: 'World Tours' },
      { src: WorldPhoto26, category: 'World Tours' },
      { src: WorldPhoto27, category: 'World Tours' },
      { src: WorldPhoto28, category: 'World Tours' },
      { src: WorldPhoto29, category: 'World Tours' },
      { src: WorldPhoto30, category: 'World Tours' },
      { src: WorldPhoto31, category: 'World Tours' },
      { src: WorldPhoto32, category: 'World Tours' },
      { src: WorldPhoto33, category: 'World Tours' },
      { src: WorldPhoto34, category: 'World Tours' },
      { src: WorldPhoto35, category: 'World Tours' }
    ],
    ATACARNET : [
      { src: concert18, category: 'ATA-CARNET' },
      { src: Carnet4, category: 'ATA-CARNET' },
      { src: Carnet5, category: 'ATA-CARNET' },
      { src: Carnet6, category: 'ATA-CARNET' },
      { src: Carnet3, category: 'ATA-CARNET' }, 
      { src: Carnet1, category: 'ATA-CARNET' },
      { src: Carnet2, category: 'ATA-CARNET' },
      { src: AtaPhoto0, category: 'ATA-CARNET' },
      { src: AtaPhoto1, category: 'ATA-CARNET' },
      { src: AtaPhoto2, category: 'ATA-CARNET' },
      { src: AtaPhoto3, category: 'ATA-CARNET' },
      { src: AtaPhoto4, category: 'ATA-CARNET' },
      { src: AtaPhoto5, category: 'ATA-CARNET' },
      { src: AtaPhoto6, category: 'ATA-CARNET' },
      { src: AtaPhoto7, category: 'ATA-CARNET' },
      { src: AtaPhoto8, category: 'ATA-CARNET' },
      { src: AtaPhoto9, category: 'ATA-CARNET' },
      { src: AtaPhoto10, category: 'ATA-CARNET' },
      { src: AtaPhoto11, category: 'ATA-CARNET' },
      { src: AtaPhoto12, category: 'ATA-CARNET' },
      


    ],
    ProjectCargo: [
      { src: projectcargo1, category: 'Project Cargo' },
      { src: projectcargo2, category: 'Project Cargo' },
      { src: projectcargo3, category: 'Project Cargo' },
      { src: projectcargo4, category: 'Project Cargo' },
      { src: projectcargo5, category: 'Project Cargo' },
      { src: project1, category: 'Project Cargo' },
      { src: project2, category: 'Project Cargo' },
      { src: project3, category: 'Project Cargo' },
      { src: project4, category: 'Project Cargo' },
      { src: project5, category: 'Project Cargo' },
      { src: project6, category: 'Project Cargo' },
      { src: project7, category: 'Project Cargo' },
      { src: project8, category: 'Project Cargo' },
      { src: project9, category: 'Project Cargo' },
      { src: project10, category: 'Project Cargo' },
      { src: Cargo1, category: 'Project Cargo' },
      { src: Cargo2, category: 'Project Cargo' },
      { src: Cargo3, category: 'Project Cargo' },
      { src: Cargo4, category: 'Project Cargo' },
      { src: Cargo5, category: 'Project Cargo' },
      { src: Cargo6, category: 'Project Cargo' },
      { src: Cargo7, category: 'Project Cargo' },
      { src: Cargo8, category: 'Project Cargo' },
      { src: Cargo9, category: 'Project Cargo' },
      { src: Cargo10, category: 'Project Cargo' },
      { src: Cargo11, category: 'Project Cargo' },
      { src: Cargo12, category: 'Project Cargo' },
      { src: Cargo13, category: 'Project Cargo' },
      { src: Cargo15, category: 'Project Cargo' },
      { src: Cargo16, category: 'Project Cargo' },
      { src: Cargo17, category: 'Project Cargo' },
      { src: Cargo18, category: 'Project Cargo' },
      { src: CargoPhoto0, category: 'Project Cargo' },
      { src: CargoPhoto1, category: 'Project Cargo' },
      { src: CargoPhoto2, category: 'Project Cargo' },
      { src: CargoPhoto3, category: 'Project Cargo' },
      { src: CargoPhoto4, category: 'Project Cargo' },
      { src: CargoPhoto5, category: 'Project Cargo' },
      { src: CargoPhoto6, category: 'Project Cargo' },
      { src: CargoPhoto7, category: 'Project Cargo' },
      { src: CargoPhoto8, category: 'Project Cargo' },
      { src: CargoPhoto9, category: 'Project Cargo' },
      { src: CargoPhoto10, category: 'Project Cargo' },
      { src: CargoPhoto11, category: 'Project Cargo' },
      { src: CargoPhoto12, category: 'Project Cargo' },
      { src: CargoPhoto13, category: 'Project Cargo' },
      { src: CargoPhoto14, category: 'Project Cargo' },
      { src: CargoPhoto15, category: 'Project Cargo' },
      { src: CargoPhoto16, category: 'Project Cargo' },
      { src: CargoPhoto17, category: 'Project Cargo' },
      { src: CargoPhoto18, category: 'Project Cargo' },
      { src: CargoPhoto19, category: 'Project Cargo' },
      { src: CargoPhoto20, category: 'Project Cargo' },
      { src: CargoPhoto21, category: 'Project Cargo' },
      { src: CargoPhoto22, category: 'Project Cargo' },
      { src: CargoPhoto23, category: 'Project Cargo' },
      { src: project11, category: 'Project Cargo' },
      { src: project12, category: 'Project Cargo' },
      { src: project13, category: 'Project Cargo' },
      { src: project14, category: 'Project Cargo' },
      { src: project15, category: 'Project Cargo' },
      { src: project16, category: 'Project Cargo' },
      { src: project17, category: 'Project Cargo' },
      { src: project18, category: 'Project Cargo' },
      { src: project19, category: 'Project Cargo' },
      { src: project20, category: 'Project Cargo' },
      { src: project21, category: 'Project Cargo' },
      { src: project22, category: 'Project Cargo' },
      { src: project23, category: 'Project Cargo' },
      { src: project24, category: 'Project Cargo' },
      { src: project25, category: 'Project Cargo' },
      { src: project26, category: 'Project Cargo' },
      { src: project27, category: 'Project Cargo' },
      { src: project28, category: 'Project Cargo' },
      { src: project29, category: 'Project Cargo' },
      { src: project30, category: 'Project Cargo' },
      { src: project31, category: 'Project Cargo' },
      { src: project32, category: 'Project Cargo' },
      { src: project33, category: 'Project Cargo' },
      { src: project34, category: 'Project Cargo' },
      { src: project35, category: 'Project Cargo' },
      { src: project36, category: 'Project Cargo' },
      { src: project37, category: 'Project Cargo' },
      { src: project38, category: 'Project Cargo' },
      { src: project39, category: 'Project Cargo' },
      { src: project40, category: 'Project Cargo' }
    ]
  };


  return (
    <section id="gallery" className="gallery-section">
      
      <div className="container">

        {/* Filter Buttons */}
        <div className="d-flex flex-wrap justify-content-center mb-5">
          <button
            className={`filter-button ${filter === 'Concerts' ? 'active' : ''}`}
            onClick={() => handleFilterChange('Concerts')}
          >
            <i className={`fas fa-globe me-2 ${filter === 'Concerts' ? '' : 'inactive-icon'}`}></i>
            World Tours
          </button>
          <button
            className={`filter-button ${filter === 'ATACARNET' ? 'active' : ''}`}
            onClick={() => handleFilterChange('ATACARNET')}
          >
            <i className={`fas fa-file-contract me-2 ${filter === 'ATACARNET' ? '' : 'inactive-icon'}`}></i>
            ATA Carnet
          </button>
          <button
            className={`filter-button ${filter === 'ProjectCargo' ? 'active' : ''}`}
            onClick={() => handleFilterChange('ProjectCargo')}
          >
            <i className={`fas fa-shipping-fast me-2 ${filter === 'ProjectCargo' ? '' : 'inactive-icon'}`}></i>
            Project Cargo
          </button>
        </div>


        {/* ATA Carnet Description */}
        {filter === 'ATACARNET' && (
          <div className="row mb-5">
            <div className="col-lg-10 mx-auto">
              <div className="description-card">
                <h3 className="description-title mb-4">
                  ATA Carnet Milestone Achievement
                </h3>
                <p className="text-muted lh-lg description-text">
                  Team RCS has successfully implemented the <strong>first-ever ATA Carnet shipment in Clark for Dua Lipa's Radical Optimism World Tour.</strong>
                  This milestone was made possible through the dedication and collaboration of our team, the <strong>Philippine Chamber of Commerce and Industry (PCCI)</strong>, and the <strong>Bureau of Customs Clark</strong>. Given that this was the first ATA Carnet shipment, it required a hands-on approach and a shared effort to navigate and familiarize ourselves with the process. By working hand-in-hand and ensuring seamless coordination, we were able to execute this complex undertaking smoothly and on time. This achievement highlights the strength of teamwork, innovation, and perseverance in overcoming challenges.
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Loading State */}
        {isLoading && (
          <div className="text-center py-5">
            <div className="loading-spinner mx-auto mb-3"></div>
            <p className="text-muted">Loading projects...</p>
          </div>
        )}

        {/* Gallery Grid */}
        {!isLoading && (
          <div className="row g-4">
            {getFilteredImages().map((img, index) => (
              <div 
                key={`${filter}-${index}`}
                className={`col-sm-6 col-md-4 col-lg-3 ${visibleImages.includes(index) ? 'gallery-item-animate' : ''}`}
                style={{
                  opacity: visibleImages.includes(index) ? 1 : 0,
                  transition: 'opacity 0.3s ease'
                }}
              >
                <div 
                  className="image-container"
                  onClick={() => handleImageClick(img.src)}
                  onMouseEnter={(e) => {
                    const overlay = e.currentTarget.querySelector('.image-overlay');
                    const icon = e.currentTarget.querySelector('.zoom-icon');
                    if (overlay) {
                      overlay.style.opacity = '1';
                      overlay.style.transform = 'scale(1)';
                    }
                    if (icon) icon.style.transform = 'scale(1.2)';
                  }}
                  onMouseLeave={(e) => {
                    const overlay = e.currentTarget.querySelector('.image-overlay');
                    const icon = e.currentTarget.querySelector('.zoom-icon');
                    if (overlay) {
                      overlay.style.opacity = '0';
                      overlay.style.transform = 'scale(1.05)';
                    }
                    if (icon) icon.style.transform = 'scale(1)';
                  }}
                >
                  <img 
                    src={img.src} 
                    alt={`${img.category} project ${index + 1}`} 
                    className="img-fluid gallery-image"
                  />
                  <div className="image-overlay">
                    <i className="fas fa-search-plus zoom-icon mb-2"></i>
                    <span className="text-white fw-bold category-text">
                      {img.category}
                    </span>
                    <span className="text-white-50 mt-1 view-text">
                      Click to view
                    </span>
                  </div>
                  
                </div>
              </div>
            ))}
          </div>
        )}

        {/* No Results State */}
        {!isLoading && getFilteredImages().length === 0 && (
          <div className="text-center py-5">
            <i className="fas fa-search no-results-icon"></i>
            <h4 className="text-muted mb-2">No projects found</h4>
            <p className="text-muted">Try adjusting your search terms or filters</p>
          </div>
        )}
      </div>

      {/* Enhanced Modal */}
      {modalImage && (
        <div className="modal-overlay" onClick={closeModal}>
          {/* Close Button */}
          <button onClick={closeModal} className="modal-close-button">
            <i className="fas fa-times"></i>
          </button>
          
          {/* Image */}
          <img 
            src={modalImage} 
            className="modal-image"
            alt="Full-size view"
            onClick={(e) => e.stopPropagation()}
          />
          
        </div>
      )}
    </section>
  );
};

export default GallerySec;
